import { configureStore } from '@reduxjs/toolkit'
import coursesReducer from './courses'
import examsReducer from './exams'
import questionsReducer from './questions'
import UsersReducer from './users'
import guestsReducer from './guests'

const reducer = {
  exams: examsReducer,
  courses: coursesReducer,
  questions: questionsReducer,
  users: UsersReducer,
  guests: guestsReducer,
}

export const store = configureStore({
  reducer: reducer
})
